import { getMarkerContentStyle, getMarkerTypographySize, getMarkerIconSize } from '../helpers/Marker.helpers.js';

var useMarkerContent = function useMarkerContent(_ref) {
  var type = _ref.type,
    _ref$hierarchy = _ref.hierarchy,
    hierarchy = _ref$hierarchy === void 0 ? 'primary' : _ref$hierarchy,
    _ref$state = _ref.state,
    state = _ref$state === void 0 ? 'current' : _ref$state,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size;
  return {
    variant: getMarkerTypographySize(size),
    textColor: getMarkerContentStyle(type, hierarchy, state, false).textColor
  };
};
var useMarkerIcon = function useMarkerIcon(_ref2) {
  var type = _ref2.type,
    _ref2$hierarchy = _ref2.hierarchy,
    hierarchy = _ref2$hierarchy === void 0 ? 'primary' : _ref2$hierarchy,
    _ref2$state = _ref2.state,
    state = _ref2$state === void 0 ? 'current' : _ref2$state,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? 'default' : _ref2$size;
  return {
    size: getMarkerIconSize(size, hierarchy),
    color: getMarkerContentStyle(type, hierarchy, state, true).textColor
  };
};

export { useMarkerContent, useMarkerIcon };
//# sourceMappingURL=useMarker.js.map
